import('./bootstrap')
import Vue from 'vue'
import 'cropperjs/dist/cropper.css'

import * as plugins from './plugins'
import App from './App.vue'
import router from './router'
import store from './store'
import axiosInterceptorsSetup from '@/config/axios-config'
import Icon from '@/components/Icon'

Vue.prototype.$eventBus = new Vue()

Vue.component('Icon', Icon)

axiosInterceptorsSetup(store)

new Vue({
	el: '#app',
	render: (h) => h(App),
	router,
	store,
	...plugins,
})
